export default __webpack_public_path__ + "img/a997fbac1ebf8b15b6ead2100c1f75e7.png";